<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Consola BD",
            items: [
                { text: "Configuración", href: "/" },
                { text: "Consola BD", active: true }
            ],
            loadingTablas: false,
            loadingRegistros: false,
            loadingSql: false,
            tablas: [],
            tablaSeleccionada: "",
            columnas: [],
            pkColumns: [],
            registros: [],
            filtroTabla: "",
            paginacion: {
                page: 1,
                per_page: 25,
                total: 0,
                last_page: 1,
                sort_by: "id",
                sort_dir: "desc"
            },
            sql: "SELECT * FROM users LIMIT 50",
            sqlResultado: [],
            sqlMeta: null,
            editandoPk: null,
            editData: {},
            error: "",
            mensaje: ""
        };
    },
    computed: {
        esUsuarioAutorizado() {
            return Number(this.user && this.user.id) === 1;
        },
        hayTablaSeleccionada() {
            return !!this.tablaSeleccionada;
        },
        columnasEditables() {
            if (!this.columnas.length) {
                return [];
            }

            return this.columnas.filter((col) => !this.pkColumns.includes(col));
        },
        sqlHeaders() {
            if (!Array.isArray(this.sqlResultado) || !this.sqlResultado.length) {
                return [];
            }

            return Object.keys(this.sqlResultado[0]);
        },
        registrosFiltrados() {
            if (!Array.isArray(this.registros)) {
                return [];
            }

            const filtro = (this.filtroTabla || "").toString().trim().toLowerCase();
            if (!filtro) {
                return this.registros;
            }

            return this.registros.filter((row) => {
                return this.columnas.some((col) => {
                    const value = row[col];
                    return (value === null || value === undefined ? "" : String(value)).toLowerCase().includes(filtro);
                });
            });
        },
        registrosMostrados() {
            return Array.isArray(this.registrosFiltrados) ? this.registrosFiltrados.length : 0;
        }
    },
    methods: {
        limpiarMensajes() {
            this.error = "";
            this.mensaje = "";
        },
        onTablaChange() {
            this.filtroTabla = "";
            this.cargarRegistros(true);
        },
        async cargarTablas() {
            this.loadingTablas = true;
            this.limpiarMensajes();

            try {
                const response = await axios.get('/api/dbadmin/tablas');
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudieron cargar las tablas.';
                    return;
                }

                this.tablas = Array.isArray(data.tablas) ? data.tablas : [];
                if (!this.tablaSeleccionada && this.tablas.length > 0) {
                    this.tablaSeleccionada = this.tablas[0].tabla;
                }
            } catch (e) {
                this.error = 'Error cargando tablas.';
                this.validar403(e);
            } finally {
                this.loadingTablas = false;
            }
        },
        async cargarRegistros(resetPage = false) {
            if (!this.tablaSeleccionada) {
                return;
            }

            if (resetPage) {
                this.paginacion.page = 1;
            }

            this.loadingRegistros = true;
            this.limpiarMensajes();

            try {
                const params = {
                    page: this.paginacion.page,
                    per_page: this.paginacion.per_page,
                    sort_by: this.paginacion.sort_by,
                    sort_dir: this.paginacion.sort_dir,
                };
                const response = await axios.get(`/api/dbadmin/tabla/${encodeURIComponent(this.tablaSeleccionada)}`, { params });
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudieron cargar los registros.';
                    return;
                }

                this.columnas = Array.isArray(data.columnas) ? data.columnas : [];
                this.pkColumns = Array.isArray(data.pk) ? data.pk : [];
                this.registros = Array.isArray(data.registros) ? data.registros : [];
                this.paginacion = Object.assign({}, this.paginacion, data.paginacion || {});
            } catch (e) {
                this.error = 'Error cargando registros de la tabla.';
                this.validar403(e);
            } finally {
                this.loadingRegistros = false;
            }
        },
        cambiarOrden(columna) {
            if (!columna || columna === '__pk') {
                return;
            }

            if (this.paginacion.sort_by === columna) {
                this.paginacion.sort_dir = this.paginacion.sort_dir === 'asc' ? 'desc' : 'asc';
            } else {
                this.paginacion.sort_by = columna;
                this.paginacion.sort_dir = 'asc';
            }

            this.cargarRegistros();
        },
        paginaAnterior() {
            if (this.paginacion.page <= 1) {
                return;
            }
            this.paginacion.page -= 1;
            this.cargarRegistros();
        },
        paginaSiguiente() {
            if (this.paginacion.page >= this.paginacion.last_page) {
                return;
            }
            this.paginacion.page += 1;
            this.cargarRegistros();
        },
        abrirEdicion(row) {
            this.editandoPk = Object.assign({}, row.__pk || {});
            this.editData = {};

            this.columnasEditables.forEach((col) => {
                this.editData[col] = row[col];
            });

            this.$bvModal.show('db-admin-edit-modal');
        },
        async guardarEdicion() {
            if (!this.tablaSeleccionada || !this.editandoPk) {
                return;
            }

            this.limpiarMensajes();

            try {
                const response = await axios.post(`/api/dbadmin/tabla/${encodeURIComponent(this.tablaSeleccionada)}/actualizar`, {
                    pk: this.editandoPk,
                    data: this.editData,
                });

                const data = response.data || {};
                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudo actualizar el registro.';
                    return;
                }

                this.mensaje = data.mensaje || 'Registro actualizado.';
                this.$bvModal.hide('db-admin-edit-modal');
                this.cargarRegistros();
            } catch (e) {
                this.error = (e.response && e.response.data && e.response.data.mensaje)
                    ? e.response.data.mensaje
                    : 'Error actualizando registro.';
                this.validar403(e);
            }
        },
        async eliminarRegistro(row) {
            const ok = window.confirm('¿Eliminar este registro? Esta acción no se puede deshacer.');
            if (!ok) {
                return;
            }

            this.limpiarMensajes();

            try {
                const response = await axios.post(`/api/dbadmin/tabla/${encodeURIComponent(this.tablaSeleccionada)}/eliminar`, {
                    pk: row.__pk || {},
                });
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudo eliminar el registro.';
                    return;
                }

                this.mensaje = data.mensaje || 'Registro eliminado.';
                this.cargarRegistros();
            } catch (e) {
                this.error = (e.response && e.response.data && e.response.data.mensaje)
                    ? e.response.data.mensaje
                    : 'Error eliminando registro.';
                this.validar403(e);
            }
        },
        async ejecutarSql() {
            this.loadingSql = true;
            this.limpiarMensajes();
            this.sqlResultado = [];
            this.sqlMeta = null;

            try {
                const response = await axios.post('/api/dbadmin/sql', {
                    sql: this.sql,
                });

                const data = response.data || {};
                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudo ejecutar la sentencia SQL.';
                    return;
                }

                this.mensaje = data.mensaje || 'SQL ejecutado correctamente.';
                if (data.tipo === 'select') {
                    this.sqlResultado = Array.isArray(data.resultados) ? data.resultados : [];
                    this.sqlMeta = {
                        tipo: data.tipo,
                        total: data.total,
                        duracion_ms: data.duracion_ms,
                    };
                } else {
                    this.sqlMeta = {
                        tipo: data.tipo,
                        afectados: data.afectados,
                        duracion_ms: data.duracion_ms,
                    };
                    this.cargarRegistros();
                }
            } catch (e) {
                this.error = (e.response && e.response.data && e.response.data.mensaje)
                    ? e.response.data.mensaje
                    : 'Error ejecutando SQL.';
                this.validar403(e);
            } finally {
                this.loadingSql = false;
            }
        },
        validar403(error) {
            const status = error && error.response ? error.response.status : null;
            if (status === 403) {
                window.location.href = '/';
            }
        },
        getCellTitle(value) {
            if (value === null || value === undefined) {
                return '';
            }

            return String(value);
        }
    },
    async created() {
        if (!this.esUsuarioAutorizado) {
            window.location.href = '/';
            return;
        }

        await this.cargarTablas();
        await this.cargarRegistros(true);
    }
};
</script>

<template>
    <Layout>
        <div v-if="!esUsuarioAutorizado"></div>
        <template v-else>
            <PageHeader :title="title" :items="items" />

            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="mensaje" class="alert alert-success">{{ mensaje }}</div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label><strong>Tabla</strong></label>
                            <select class="form-control" v-model="tablaSeleccionada" @change="onTablaChange">
                                <option v-for="item in tablas" :key="item.tabla" :value="item.tabla">
                                    {{ item.tabla }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label><strong>Registros por página</strong></label>
                            <select class="form-control" v-model.number="paginacion.per_page" @change="cargarRegistros(true)">
                                <option :value="10">10</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label><strong>Buscar</strong></label>
                            <input
                                class="form-control"
                                v-model.trim="filtroTabla"
                                placeholder="Filtrar filas visibles de esta tabla"
                            />
                        </div>
                        <div class="col-md-2 d-flex align-items-end justify-content-end">
                            <button class="btn btn-primary" @click="cargarRegistros()" :disabled="loadingRegistros || !hayTablaSeleccionada">
                                {{ loadingRegistros ? 'Cargando...' : 'Recargar tabla' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">Registros de {{ tablaSeleccionada || '-' }}</h5>
                        <small class="text-muted">Mostrados: {{ registrosMostrados }}</small>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm table-striped table-hover db-admin-table">
                            <thead>
                                <tr>
                                    <th v-for="col in columnas" :key="col" style="cursor:pointer" @click="cambiarOrden(col)">
                                        {{ col }}
                                        <span v-if="paginacion.sort_by === col">({{ paginacion.sort_dir }})</span>
                                    </th>
                                    <th style="width: 140px;">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in registrosFiltrados" :key="idx">
                                    <td v-for="col in columnas" :key="col" :title="getCellTitle(row[col])">
                                        <span class="cell-truncate">{{ row[col] }}</span>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-warning mr-1" @click="abrirEdicion(row)">Editar</button>
                                        <button class="btn btn-sm btn-danger" @click="eliminarRegistro(row)">Eliminar</button>
                                    </td>
                                </tr>
                                <tr v-if="!registrosFiltrados.length">
                                    <td :colspan="columnas.length + 1" class="text-center text-muted">Sin registros</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-2">
                        <small class="text-muted">Mostrando {{ registrosMostrados }} filas filtradas de {{ paginacion.total }} registros cargados</small>
                        <div>
                            <button class="btn btn-sm btn-light mr-2" @click="paginaAnterior" :disabled="paginacion.page <= 1">Anterior</button>
                            <span>Pag {{ paginacion.page }} / {{ paginacion.last_page }}</span>
                            <button class="btn btn-sm btn-light ml-2" @click="paginaSiguiente" :disabled="paginacion.page >= paginacion.last_page">Siguiente</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h5 class="mb-3">Consola SQL</h5>
                    <p class="text-muted mb-2">
                        Permitido: SELECT, INSERT, UPDATE, DELETE. Bloqueado: sentencias estructurales (DROP/ALTER/CREATE/TRUNCATE...).
                    </p>
                    <textarea class="form-control mb-2" rows="6" v-model="sql"></textarea>
                    <button class="btn btn-dark" @click="ejecutarSql" :disabled="loadingSql">
                        {{ loadingSql ? 'Ejecutando...' : 'Ejecutar SQL' }}
                    </button>

                    <div v-if="sqlMeta" class="mt-3">
                        <small class="text-muted">Tipo: {{ sqlMeta.tipo }} | Duración: {{ sqlMeta.duracion_ms }} ms</small>
                        <small v-if="sqlMeta.total !== undefined" class="text-muted ml-2">Filas: {{ sqlMeta.total }}</small>
                        <small v-if="sqlMeta.afectados !== undefined" class="text-muted ml-2">Afectados: {{ sqlMeta.afectados }}</small>
                    </div>

                    <div class="table-responsive mt-2" v-if="sqlResultado.length">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th v-for="h in sqlHeaders" :key="h">{{ h }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in sqlResultado" :key="idx">
                                    <td v-for="h in sqlHeaders" :key="h">{{ row[h] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <b-modal id="db-admin-edit-modal" title="Editar registro" hide-footer>
                <div v-for="col in columnasEditables" :key="col" class="form-group">
                    <label>{{ col }}</label>
                    <input v-model="editData[col]" class="form-control" />
                </div>

                <div class="text-right">
                    <button class="btn btn-light mr-2" @click="$bvModal.hide('db-admin-edit-modal')">Cancelar</button>
                    <button class="btn btn-primary" @click="guardarEdicion">Guardar</button>
                </div>
            </b-modal>
        </template>
    </Layout>
</template>

<style scoped>
.db-admin-table {
    table-layout: fixed;
    width: 100%;
}

.db-admin-table th,
.db-admin-table td {
    font-size: 12px;
    padding: 0.3rem;
    max-width: 130px;
    vertical-align: top;
}

.cell-truncate {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    line-height: 1.15;
}
</style>
